import { useEffect, useState } from 'react';
import { getSession, onAuthChange, refreshUser, signOut, type Session } from './auth';

export function useAuth() {
  const [session, setSession] = useState<Session | null>(() => getSession());

  useEffect(() => {
    const unsubscribe = onAuthChange(setSession);
    // Validate the stored token against the API once per boot — catches
    // revoked access and role changes without forcing a re-login.
    void refreshUser();
    return unsubscribe;
  }, []);

  return { session, user: session?.user ?? null, loading: false, signOut };
}
